import { render } from "./PosReceipt.vue?vue&type=template&id=2ea59b7f&scoped=true&ts=true"
import script from "./PosReceipt.vue?vue&type=script&lang=ts"
export * from "./PosReceipt.vue?vue&type=script&lang=ts"

import "./PosReceipt.vue?vue&type=style&index=0&id=2ea59b7f&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea59b7f"]])

export default __exports__